import _default from './Header';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Header/index.js
// module id = 870
// module chunks = 0